'use client'

import { usePostHog } from 'posthog-js/react'
import { useMemo } from 'react'

export function useABTest() {
  const posthog = usePostHog()
  
  const abTestResults = useMemo(() => {
    if (!posthog) {
      return {
        showStaticImages: false, // Default to videos
        isLoading: true
      }
    }

    // Get the feature flag for static images vs videos
    let showStaticImagesVWO506 = false
    if(posthog.getFeatureFlag('htma-506-home-e-replace-feature-demo-movies-with-static-images-ice-22-30') === 'test'){
      showStaticImagesVWO506 = true
    }else{
      showStaticImagesVWO506 = false
    }

    let showTableSubheadlineVWO506 = true
    if(posthog.getFeatureFlag('htma-548-features-e-simplify-mobile-feature-comparison-table-for-better-scannability-ice-22-30') === 'test'){
      showTableSubheadlineVWO506 = false
    }
    
    return {
      showStaticImages:showStaticImagesVWO506,
      showTableSubheadline:showTableSubheadlineVWO506,
      isLoading: false
    }
  }, [posthog])

  return abTestResults
}
